<template>
  <TableTemplate
    :columnVariables="tableColumnVariables"
    :columns="tableColumns"
    :skeletonClass="skeletonClass"
    :value="shopProducts"
    :enable-sorting="true"
    :page="page"
    :max="maximum"
    @set-page="v => page = v"
    ref="table"
  >
    <template #above>
      <TableHeader
        title="Winkel Voorraad"
        :show-button="showButton"
        :always-show-multi-select-checkbox="true"
        :refetch="refetch"
        @setting-layout="customizeSetting"
        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search" />
        <FormSearchSelector
          v-model="site"
          class="ml-2 website-search"
          id="website"
          placeholder="Zoek website..."
          endpoint="/api/websites"
          titleField="domainname"
          searchParameter="name"
          :infinite-scrolling="true"
          :table="true"
          v-slot="item"
          @select-item="fetchData"
        >
          <div class="p-1 item">
            {{ item.domainname }}
          </div>
        </FormSearchSelector>
        <RefreshBtn :loading="isLoadingTableResult" @click.native="fetchData({uid: site})" />
      </div>
      <div class="d-flex flex-row-reverse">
         <MultiplePageSizesSelection
           v-model="page_size"
           :available-values="availablePageSizeValues"
         />
       </div>
    </template>
    <template #cell-quantity="{ value, item }">
      <FormPlusMinusInput
        @input="newValue => updateProduct({ item, value, newValue })"
        :number="value"
      ></FormPlusMinusInput>

    </template>
    <template #empty-state>
      <EmptyStatePlaceholder title="Er zijn geen winkel vooraad">
        <svg
          width="18"
          height="18"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
        >
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)">
            <g>
              <path
                d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "></path>
              <line
                x1="7.5"
                y1="3"
                x2="7.5"
                y2="6"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "
              ></line>
              <circle
                cx="7.5"
                cy="9"
                r="0.5"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "
              ></circle>
            </g>
          </g>
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>
<script>
import selectMultipleItems from "@/mixins/selectMultipleItems"
import TableTemplate from "@/layout/Table/TableTemplate.vue";
import tableFieldOptions from "@/mixins/tableFieldOptions";
import table from "@/mixins/table";
import TableHeader from "@/components/Catalog/ProductTable/TableHeader.vue";
import TableMainSearchField from "@/layout/TableMainSearchField.vue";
import FormSearchSelector from '@/components/Inputs/FormSearchSelector.vue';
import RefreshBtn from "@/layout/RefreshBtn.vue";
import EmptyStatePlaceholder from "@/layout/EmptyStatePlaceholder.vue";
import FormPlusMinusInput from "@/components/Inputs/FormPlusMinusInput.vue";
import MultiplePageSizesSelection from '@/layout/Table/MultiplePageSizesSelection.vue';

export default {
  metaInfo: {
    title: "Winkel Voorraad"
  },
  components: {
    FormPlusMinusInput,
    EmptyStatePlaceholder,
    RefreshBtn,
    FormSearchSelector,
    TableMainSearchField,
    TableHeader,
    TableTemplate,
    MultiplePageSizesSelection
  },
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: 'shop-stocks',
      columnTranslationMaps: {
        "SKU": "sku",
        "Naam": "name",
        "Voorraad": "quantity"
      },
      defaultColumns: [
        "SKU", "Naam", "Voorraad"
      ],
      columnConfigurationId: "shop-stocks",
      params: {
        search: "",
        site: "",
      },
      page_size: 50
    })
  ],
  data() {
    return {
      shopProducts: [],
      reason: 'MODIFIED_IN_BACKOFFICE',
      total: 1
    };
  },
  methods: {
    async fetchData(item){
      if(!item) return
      const { uid } = item;
      const response = (await this.axios.get(`/api/websites/${uid}/inventory`, {
        params: {
          page: this.page,
          page_size: this.page_size,
          sort: this.sort,
          sort_type: this.order
        }
      })).data
      const { results, total } = response
      if (results) {
        this.shopProducts = results
        this.total = total
      }
    },
    async updateProduct(data) {
      const { item, value: val, newValue } = data;
      const { source, value } = newValue;
      let quantity = value;
      if (source === 'INPUT') quantity = parseInt(value) - parseInt(val)
      const payload = {
        reason: this.reason,
        stocks: [
          { sku: item.sku, quantity }
        ]
      }
      await this.$handlePromise(this.axios.post(`/api/websites/${this.site}/inventory`, payload));
      this.$store.dispatch('clearCacheSearch', 'shop_stocks' );
      this.$success("Voorraad geüpdatet!")
      this.refetch()
    }
  },
  created() {
    if (this.site) this.fetchData({ uid: this.site })
  },
  watch: {
    sorting() {
      this.fetchData({ uid: this.site })
    },
    page_size() {
      this.page = 1
      this.fetchData({ uid: this.site })
    },
    page() {
      this.fetchData({ uid: this.site })
    }
  },
  computed: {
    sorting() {
      return this.sort + this.order
    },
    availablePageSizeValues() {
      return [10, 20, 50, 100, 200]
    },
    maximum() {
      return Math.ceil(this.total / this.page_size)
    }
  }
}
</script>
